import propTypes from "prop-types"
import { useEffect } from "react"
import { Modal, ModalBody, ModalHeader, Alert } from "reactstrap"
import { useQuery, useMutation } from "@tanstack/react-query"
import { Loading } from "components"
import { getBranch, editBranch } from "services/branch-offices"
import BranchesForm from "./BranchesForm"

const EditModalForm = ({ isOpen, toggle, branchId, setShowAlertSuccess, setMsgSuccess }) => {
  const {
    data,
    error,
    isError,
    isLoading,
    refetch,
  } = useQuery(["branch", branchId], () => getBranch(branchId))

  const {
    isLoading: isLoadingEdit,
    isError: isErrorEdit,
    error: errorEdit,
    isSuccess: isSuccessEdit,
    mutateAsync,
  } = useMutation(["branch", branchId], (data) => editBranch(branchId, data))

  useEffect(() => {
    if (isSuccessEdit) {
      setMsgSuccess("Sucursal modificada satisfactoriamente")
      setShowAlertSuccess(true)
      toggle()
    }
  }, [isSuccessEdit])

  const submit = async (data) => {
    await mutateAsync(data)
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered={true} size="lg" backdrop="static">
      <ModalHeader toggle={toggle} charcode="X">
        Editar Sucursal
      </ModalHeader>
      <ModalBody>
        {isLoading ? (
          <div className="text-center">
            <Loading isLoading={isLoading} size={2} />
          </div>
        ) : isError ? (
          <div className="text-center">
            <Alert color="danger" isOpen={isError}>
              {error?.errors?.map((error) => error?.message)}
            </Alert>
          </div>
        ) : (
          <BranchesForm
            data={data}
            error={errorEdit}
            isCreateModal={false}
            isError={isErrorEdit}
            isLoading={isLoadingEdit}
            refetchData={refetch}
            submit={submit}
            toggle={toggle}
          />
        )}
      </ModalBody>
    </Modal>
  )
}

EditModalForm.defaultProps = {
  branchId: null,
}

EditModalForm.propTypes = {
  isOpen: propTypes.any,
  branchId: propTypes.number,
  refetch: propTypes.func,
  setMsgSuccess: propTypes.func,
  setShowAlertSuccess: propTypes.func,
  toggle: propTypes.func,
}

export default EditModalForm
